import { PubSub } from '../../../../bark-core';

export function SellerViewport() {
	let instanceVars = {
		mobileThreshold: 768,
		tabletThreshold: 992,
		containerClass: 'seller-dash-v2',
		columnClass: 'fixed-height-column',
		projectLoaderClass: 'project-details-loader',
		classes: {
			mobile: ['mobile'],
			tablet: ['tablet'],
			desktop: ['desktop'],
		},
		viewType: null,
		init: () => {
			this.bindListeners();
			this.refresh();
		},
		getWindowWidth: () => $(window).width(),
		getContainer: () => $('.' + this.containerClass),
		getColumns: () => $('.' + this.columnClass),
		getFixedHeightElements: () => $('.' + this.projectLoaderClass),
		isMobile: () => this.viewType === 'mobile',
		isTablet: () => this.viewType === 'tablet',
		isDesktop: () => this.viewType === 'desktop',
		getViewType: (force) => {
			if (!this.viewType || force) {
				if (this.getWindowWidth() < this.mobileThreshold) {
					this.viewType = 'mobile';
				} else if (this.getWindowWidth() < this.tabletThreshold) {
					this.viewType = 'tablet';
				} else {
					this.viewType = 'desktop';
				}
			}
			return this.viewType;
		},
		setClasses: () => {
			$.each(this.classes, (viewType, classes) => {
				if (viewType === this.getViewType()) {
					this.getContainer().addClass(classes.join(' '));
				} else {
					this.getContainer().removeClass(classes.join(' '));
				}
			});
			if (this.isDesktop()) {
				$('#dashboard-sidebar-modal .modal-dialog').removeClass('modal-fullscreen');
			} else {
				$('#dashboard-sidebar-modal .modal-dialog').addClass('modal-fullscreen');
			}
		},
		updateColumnHeights: () => {
			let headerHeight = $('.bark-header').height();
			let clientHeight = Math.max(
				document.documentElement.clientHeight,
				window.innerHeight || 0,
			);
			let height = clientHeight - headerHeight;
			this.getColumns().css('max-height', height + 'px');
		},
		refresh: () => {
			this.getViewType(true);
			this.setClasses();
			this.updateColumnHeights();
		},
		bindListeners: () => {
			$(window).resize(() => {
				this.refresh();
				this.fireEvent('viewport-resize', this);
			});
		},
	};

	Object.assign(this, PubSub, instanceVars);
	this.init();
	return this;
}
